import { useClearRefinements, useRefinementList } from 'react-instantsearch';

import ScrollableRow from '~/components/Header/lib/components/scrollable-row';
import { Pill } from '~/components/OddscheckerPlus/components/cxy';
import { type BettingInsights } from '~/configuration/betting-insights/BettingInsightsConfig';
import { type EsIndex } from '~/configuration/betting-insights/types';
import { withLock } from '~/hocs/withLock';

import styles from './styles/CategoriesRefinement.module.css';

export function CategoriesRefinement<TIndex extends EsIndex>({
  categories,
  hasResults,
  isDisabled = false




}: {categories: BettingInsights<TIndex>['ui']['results']['categories'];hasResults: boolean;isDisabled?: boolean;}) {
  const { attribute, order } = categories;

  const allText = 'All';

  const { items, refine } = useRefinementList({
    attribute
  });
  const { refine: clearRefinement } = useClearRefinements({
    includedAttributes: [attribute]
  });

  const toggleCategory = (category: string) => {
    const selected = items.find(
      (item) => item.isRefined && item.value === category
    );

    if (!selected) {
      clearRefinement();
    }

    if (category !== allText) {
      refine(category);
    }
  };

  return (
    <section className={styles.categories} data-testid="categories">
			<ScrollableRow className={styles.sportFilter}>
				<Pill
          active={items.every((item) => !item.isRefined)}
          className={styles.pill}
          disabled={isDisabled || !hasResults && !items.length}
          onClick={() => toggleCategory(allText)}>

					{allText}
				</Pill>
				{items.
        sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value)).
        map((item) =>
        <Pill
          active={item.isRefined}
          className={styles.pill}
          disabled={isDisabled}
          key={item.value}
          onClick={() => toggleCategory(item.value)}>

							{item.label}
						</Pill>
        )}
			</ScrollableRow>
		</section>);

}

export const LockableCategoriesRefinement = withLock(
  CategoriesRefinement,
  'componentWall',
  'categories'
);